import React,{useState,useEffect, useContext} from "react";
import EditReport from "../../../components/SVGComponents/EditReport";
import Submitted from "../../../components/SVGComponents/Submitted";
import Chat from "../../../components/SVGComponents/Chat";
import Download from "../../../components/SVGComponents/Download";
import DownloadImage from "../../../components/SVGComponents/DownloadImage";
import { Stack, TooltipHost } from "@fluentui/react";
import Resubmitted from "../../../components/SVGComponents/Resubmitted";
import Pending from "../../../components/SVGComponents/Pending";
import Moment from "moment";
import { Icon } from "@fluentui/react";
import { BADGE_COLOR_NAME, BADGE_INFO_OBJ, CUSTOM_STYLES, CXR_TABS_NAME, QC_TABS, QC_TABS_NAME, REPORT_DONE_STATUS, REPORTED_TABS_NAME, SHOW_EXTERNAL_REPORTING_TO_USER, SHOW_RETURNED_ROLES, SHOW_SAVED_TAG_TABS, TAB_NAME, USERTYPES } from "../../../constants/Constants";
import PencilIcon from "../../../components/SVGComponents/PencilIcon";
import ReportingIcon from "../../../components/SVGComponents/StudyList/Actions/ReportingIcon";
import PreviewStudyListIcon from "../../../components/SVGComponents/StudyList/Actions/PreviewStudyListIcon";
import DownloadReportIcon from "../../../components/SVGComponents/StudyList/Actions/DownloadReportIcon";
import userContext from "../../../context/users/UserContext";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import { FilePDBIcon } from "@fluentui/react-icons-mdl2";
import DownloadOptions from "../../Report/components/RaiseAlertSection/DownloadOptions";
import { keyImagesPresent } from "../../StudyViewer/helpers/KeyImageUtility";
import { t } from "i18next";
import ReportDetailsBadge from "./ReportDetailsBage/ReportDetailsBadge";
import EyeIcon from "../../../components/SVGComponents/EyeIcon";
import studylistContext from "../../../context/studylist/StudylistContext";
import ReportCount from "../../../components/SVGComponents/ReportCount";
import NavIcons from "../../../components/navbar/nav-icons/NavIcons";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import DirectSubmitReport from "../../../components/SVGComponents/DirectSubmitReport";
import { directReportSubmit } from "../../../service/StudyReportService";
import WeasisViewerIcon from "../../../components/SVGComponents/StudyList/Actions/WeasisViewerIcon";
import PlatformHelper from "../../../helpers/PlatformHelper";
import { getEnv } from '../../../helpers/EnvHelper';
import { statusStyle } from "../helpers/ConstantStyles";
import themeContext from "../../../context/theme/ThemeContext";



const submissionStackStyle = {
  display: "flex",
};



const timeDateStyle = {
  fontSize: "11px",
  fontWeight: "400",
  marginTop: "5px",
};

const reportOptionsStackStyle = {
  width: "152px",
  height: "30px",
  backgroundColor: "#161616",
  borderRadius: "10px",
  alignItems: "center",
  justifyContent: "space-evenly",
};

const hospitalStackStyles = {
  fontSize: "14px",
  fontWeight: "400",
  alignItems: "center",
};

const ReportDetails = (props) => {
  const {roles,radiologistType, isActiveData, privilegedFirmDoctor ,userId } = useContext(userContext);
  const [showInfo1, setShowInfo1] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [hovering,setHovering] = useState({
    report : false,
    preview : false,
    download : false,
    downloadAIReport: false
  })

  const index = 0;
  const showForPrior = true;
  const { getThemeColor, themeName } = useContext(themeContext);

  const {
    setStudyParentId,
    openReportModal,
    setOpenReportModal,
    setModalityReport,
    reportDetails,
    getData,
    studyParentId,
    setFirmId,
    firmId,
    setIsExternal,
    handlePreviewReport,
    handlePreviewReportWithKeyImage,
    downloadReport,
    studyPatientDetails,
    setStudyPatientDetails,
    setExternalReportingLoading,
    externalReportingModalRef,
    setIsClientReportExistExternalModal,
    setIsClientReportExist,
    getConsistentDateFormat,
    getConsistentCustomDateFormat,
    setKeyImagePresentStudyList,
    downloadAIReport,
    setAlertSuccessModal,
    alertSuccessModal,
    downloadedStudyIds,
    setDownloadedStudyIds
  } = useContext(studyReportContext);

  const { setTrackOfVisited,  setRefreshRequired, refreshRequired, setShowReturnedStudyReasonModal,returnedReasonCount,showAiResults,showSavedReport} = useContext(studylistContext);

  let isBvpPlatform = (getEnv("REACT_APP_BVP_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == true) ? true : false;
  let isVdcPlatform = (getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_VDC_PLATFORM") == true) ? true : false;

  const reportStackStyle = {
    justifyContent: "flex-start",
    marginTop: "15px",
    marginBottom: "15px",
  };

  const handleEditReport = () => {
    setIsClientReportExistExternalModal(null);
    setIsClientReportExist(null);
    setOpenReportModal(null);  
    setStudyPatientDetails(()=>{
      const newItem = {...studyPatientDetails};
      newItem.patientName = props.data.row.original.patientName;
      newItem.patientId = props.data.row.original.patientId;
      return newItem;
    });
    console.log("--- Setting Key Image ---",props.data.row?.original?.keyImagePresent);
    setKeyImagePresentStudyList(props.data.row?.original?.keyImagePresent)
    setStudyParentId(studyId);
    setIsExternal(true);
   
    setFirmId(props.data.row.original?.assignmentList[0]?.firmId)
    setModalityReport(props.data.row.original.modality.name);
    
  }

  const handleRefreshTabs = (refreshRequiredTabs) => {
    const tabs = { ...refreshRequired };
    refreshRequiredTabs.forEach((tab) => (tabs[tab].alreadyLoaded = false));
    return tabs;
  };

  const handleDirectSubmitReport = async (studyId) => {
    const response = await directReportSubmit(studyId);
    if(response.status == 200 && response.data.result === "SUCCESS") {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Success";
        newItem.description = t("string-literals.nidaan-report-submitted");
        return newItem;
      });
      props.table.options.meta?.removeRowFromStudyList(studyId);
      setTrackOfVisited((prev) => [...prev, { id: studyId, visited: true }]);
      setRefreshRequired(() => handleRefreshTabs([TAB_NAME.REPORTED]));
    } else {
      setAlertSuccessModal(() => {
        const newItem = { ...alertSuccessModal };
        newItem.show = true;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  }



  let study = props.data.row.original;
  let studyId = props.data.row.original.id;
  let patientName = props.data.row.original.patientName;
  let patientId = props.data.row.original.patientId;
  let reviewerId = props.data.row.original.peerReviewAssignment?.reviewerId;
  let reviewStatus = props.data.row.original.peerReviewAssignment?.reviewStatus;
  

  const getFormatedDate = (date) => {
    var currentDate = Moment(date).local().format("llll");
    return currentDate;
  };

  

  const hospitalStackStyles = {
    fontSize: "14px",
    fontWeight: "400",
    alignItems: "center",
  };

  const customToolTipGreenTickStyles = {
    root: "study-list-report-details-green",
  }

  const customToolTipWhiteTickStyles = {
    root: "study-list-report-details-white",
  }

  const customToolTipRedTickStyles = {
    root: "study-list-report-details-red",
  }

  const customToolTipRaiseAlertStyles = {
    root: "study-list-report-details-raise-alert",
  }

  const customToolTipStyleForIcons = {
    root: "study-list-report-preview-container",
  }

  const customToolTipStyleForPreview = {
    root: "study-list-report-preview-container",
  }

  useEffect(() => {
    // Toggle the visibility every 1 second
    const interval = setInterval(() => {
      setIsVisible((prevIsVisible) => !prevIsVisible);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const checkForShowingExternalReportingActions = () => {
    if((!((roles[0] === USERTYPES.FIRMTECHNICIAN || (roles[0] === USERTYPES.FIRMDOCTOR && !props.data.row.original.showSavedReport) || roles[0] === USERTYPES.SUPERVISOR ) && CXR_TABS_NAME.includes(props.tabId)) 
    && props.tabId != TAB_NAME.CLOSED)){
      return true;
    }else{
      return false;
    }
  }

  const checkForPreviewAvailable = () => {
    if(reviewerId != null && reviewerId == userId && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE || props.tabId == TAB_NAME.EVALUATIONASSIGNED || props.tabId == TAB_NAME.EVALUATIONCOMPLETE)){
      return false
    }
    const isDraftTab = props.tabId === TAB_NAME.DRAFT;
    const hasPreviewableStatus =
      study.reportDoneStatus == 1 ||
      study.reportDoneStatus == 2 ||
      study.reportDoneStatus == REPORT_DONE_STATUS.DRAFT ||
      isDraftTab;
    if(((roles[0] == USERTYPES.FIRMADMIN ||
      roles[0] == USERTYPES.ADMIN ||
      roles[0] == USERTYPES.RADIOLOGIST ||
      roles[0] == USERTYPES.SUPERVISOR ||
      roles[0] == USERTYPES.TYPIST ||
      props.data.row.original.showSavedReport) &&
      hasPreviewableStatus &&
      (study.showReportPreviewButton || isDraftTab))){
        return true;
      }
    else{
      return false;
    }
  }

  const checkForDownloadAvailable = () => {
    if(roles[0] == USERTYPES.TYPIST){
      return false;
    }
    if(reviewerId != null && reviewerId == userId && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE || props.tabId == TAB_NAME.EVALUATIONASSIGNED || props.tabId == TAB_NAME.EVALUATIONCOMPLETE)){
      return false
    }
    if((study.reportDoneStatus == 2 
      && (study.allowDownloadReport || roles[0] == USERTYPES.ADMIN) )){
        return true;
      }
    else{
      return false;
    }
  }

  const checkForAIReportDownloadAvailable = () => {

    if(roles[0] == USERTYPES.TYPIST){
      return false;
    }else if(study.aiEmergencyMax === -3 ){
      return false;
    }
    if (
    (roles[0] == USERTYPES.FIRMDOCTOR || roles[0] == USERTYPES.FIRMTECHNICIAN) &&
    !study.showAiResult
  ) {
    return false;
  }
    return study.aiProcessed == 1 && !isVdcPlatform;
  }

  const checkForPeerReviewReportDownloadAvailable = () => {
    if(reviewerId != null && reviewStatus != 1 && (props.tabId == TAB_NAME.REVIEWCOMPLETE || props.tabId == TAB_NAME.EVALUATIONASSIGNED || props.tabId == TAB_NAME.EVALUATIONCOMPLETE)){
      return true
    }
    return false;
  }

  const checkForExternalReportingAvailable = () => {
    if((SHOW_EXTERNAL_REPORTING_TO_USER.includes(roles[0]) || props.data.row.original.showSavedReport) && !PlatformHelper.isFahes()){
      if(props.data.row.depth != 0){
        return false;
      }
      return true;
    }else{
      return false;
    }
  }

  const checkForAnyActionIsActive = () => {
    let reporting = false;
    let preview = false;
    let download = false;

    if(checkForExternalReportingAvailable()){
      reporting = true;
    }
    if(checkForPreviewAvailable()){
      preview = true;
    }
    if(checkForDownloadAvailable() ||  checkForAIReportDownloadAvailable() || checkForPeerReviewReportDownloadAvailable()){
      download = true;
    }

    if(props.data.row.depth != 0 && reporting && !preview && !download){
      return false;
    }

    return reporting || preview || download;


  }

  const getDownloadReportTooltipText = () => {
    if((checkForAIReportDownloadAvailable() && checkForDownloadAvailable())|| (checkForDownloadAvailable())){
      return t("heading.download-report")+": "+props.data.row.original.noOfReports;
    } else if(checkForPeerReviewReportDownloadAvailable()){
      return t("heading.peer-review-report")
    }
    return t("heading.download-ai-report");
  }

  const getAssignmentDate = () => {
    if(reviewerId != null && reviewerId == userId && reviewStatus == 1){
      return props.data.row.original.peerReviewAssignment.reviewAssignedDate;
    } else if(reviewerId != null && reviewerId == userId && reviewStatus == 2){
      return props.data.row.original.peerReviewAssignment.reviewSubmittedDate;
    } else{
      return props.data.row.original.assignmentList[0].assignmentDateDisplay;
    }
  }
  const getReturnedStudyCount = (study_id) => {
    let count = 0;
    if (returnedReasonCount.length > 0) {
      count = returnedReasonCount.filter((ele, index) => {
        return ele.studyId == study_id;
      })[0]?.noOfReasons;
    }
    return count > 0 ? count : null;
  };

   const checkTab = () => {
     return (
       REPORTED_TABS_NAME.includes(props.tabId) ||
       props.tabId == TAB_NAME.REVIEWASSIGNED ||
       props.tabId == TAB_NAME.REVIEWCOMPLETE ||
       props.tabId == TAB_NAME.EVALUATIONASSIGNED ||
       props.tabId == TAB_NAME.EVALUATIONCOMPLETE ||
       props.tabId == TAB_NAME.PENDING ||
       props.tabId == TAB_NAME.APPROVED ||
       props.tabId == TAB_NAME.REJECTED
     );
   };

   const getColorValue = (color) => {
     // if(themeName != "light"){
     //   return color;
     // }
     return getThemeColor("primary-color");
   };

  return (
    <>
      <div
      data-tut={"tour-report-details"}
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Stack style={reportStackStyle} >
<span className="study-list-top-badge-container"
              style={props.data.row.depth !== 0 ? { left: "4px", top: "-16px" } : {}}
              >
{roles.length > 0 && SHOW_RETURNED_ROLES.includes(roles[0]) && getReturnedStudyCount(props.data.row.original.id) != null && (
                <span
                  onClick={() => {
                    setShowReturnedStudyReasonModal({
                      studyId: props.data.row.original.id,
                      show: true,
                    });
                  }}
                  className="study-list-top-badge-item"
                  style={{ color: "rgb(3 52 98)", background: "#59ADFA",whiteSpace:"nowrap" }}
                >{`${t("study-list.badges.returned").toUpperCase()} ${getReturnedStudyCount(
                  props.data.row.original.id
                )}`}</span>
              )}
              {showForPrior && props.data.row.original.assignmentList[index]
                            ?.pTatCategoryColorClassName === BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.COLOR_NAME && ( <>
                                <CustomToolTipHost content={t("info-badge.p-tat-tooltip")} id={"p_tat_tooltip_less_than_1"}>
                                <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.p-tat-less-than-1-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.pTatDisplay} `
                                    : ""}
                                </span>
                                </CustomToolTipHost>
                              </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.pTatCategoryColorClassName === BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.COLOR_NAME && (<>
                            <CustomToolTipHost content={t("info-badge.p-tat-tooltip")} id={"p_tat_tooltip_more_than_12"}>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.p-tat-more-than-12-hr")} &nbsp;
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.pTatDisplay} `
                                    : ""}
                                </span>
                            </CustomToolTipHost>
                            </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.pTatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.COLOR_NAME && (<>
                            <CustomToolTipHost content={t("info-badge.p-tat-tooltip")} id={"p_tat_tooltip_1_to_2"}>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.p-tat-between-1-to-2-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.pTatDisplay} `
                                    : ""}
                              </span>
                            </CustomToolTipHost>
                              </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.pTatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.COLOR_NAME && (<>
                            <CustomToolTipHost content={t("info-badge.p-tat-tooltip")} id={"p_tat_tooltip_2_to_3"}>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.p-tat-between-2-to-3-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.pTatDisplay} `
                                    : ""}
                                </span>
                            </CustomToolTipHost>
                              </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.pTatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.COLOR_NAME && (<>
                            <CustomToolTipHost content={t("info-badge.p-tat-tooltip")} id={"p_tat_tooltip_3_to_12"}>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.p-tat-between-3-to-12-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.pTatDisplay} `
                                    : ""}
                                </span>
                            </CustomToolTipHost>
                              </>
            )}
              {showForPrior && props.data.row.original.assignmentList[index]
                            ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.COLOR_NAME && ( <>
                                <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_LESS_THAN_1_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.tat-less-than-1-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                                    : ""}
                                </span>
                                
                                {checkTab()  &&
                              props.data.row.original.assignmentList[index].tatRating != "" &&
                              props.data.row.original.assignmentList[index].tatRating != "0" ? (
                                <div className="study-list-tat-start-badge" style={{ position: "unset", borderRadius: "0px 0px 7px 7px", marginLeft: "5px"}}>
                                  <span className="study-list-tat-start-text">
                                    {props.data.row.original.assignmentList[index].tatRating}
                                  </span>
                                  <Icon
                                    iconName="FavoriteStarFill"
                                    className="study-list-tat-star"
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.COLOR_NAME && (<>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_MORE_THAN_12_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.tat-more-than-12-hr")} &nbsp;
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                                    : ""}
                                </span>
                                  {checkTab()  &&
                                  props.data.row.original.assignmentList[index].tatRating != "" &&
                                  props.data.row.original.assignmentList[index].tatRating !=
                                    "0" ? (
                                    <Icon
                                      iconName="FavoriteStar"
                                      className="study-list-tat-star"
                                    />
                                  ) : (
                                    ""
                                  )}
              
                              {checkTab()  &&
                              props.data.row.original.assignmentList[index].tatRating != "" &&
                              props.data.row.original.assignmentList[index].tatRating != "0" ? (
                                <div className="study-list-tat-start-badge" style={{ position: "unset", borderRadius: "0px 0px 7px 7px", marginLeft: "5px"}}>
                                  <span className="study-list-tat-start-text">
                                    {props.data.row.original.assignmentList[index].tatRating}
                                  </span>
                                  <Icon
                                    iconName="FavoriteStarFill"
                                    className="study-list-tat-star"
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.COLOR_NAME && (<>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_1_TO_2_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.tat-between-1-to-2-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                                    : ""}
                              </span>
                                {checkTab()  &&
                              props.data.row.original.assignmentList[index].tatRating != "" &&
                              props.data.row.original.assignmentList[index].tatRating != "0" ? (
                                <div className="study-list-tat-start-badge" style={{ position: "unset", borderRadius: "0px 0px 7px 7px", marginLeft: "5px"}}>
                                  <span className="study-list-tat-start-text">
                                    {props.data.row.original.assignmentList[index].tatRating}
                                  </span>
                                  <Icon
                                    iconName="FavoriteStarFill"
                                    className="study-list-tat-star"
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.COLOR_NAME && (<>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_2_TO_3_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.tat-between-2-to-3-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                                    : ""}
                                </span>
                                {checkTab()  &&
                              props.data.row.original.assignmentList[index].tatRating != "" &&
                              props.data.row.original.assignmentList[index].tatRating != "0" ? (
                                <div className="study-list-tat-start-badge" style={{ position: "unset", borderRadius: "0px 0px 7px 7px", marginLeft: "5px"}}>
                                  <span className="study-list-tat-start-text">
                                    {props.data.row.original.assignmentList[index].tatRating}
                                  </span>
                                  <Icon
                                    iconName="FavoriteStarFill"
                                    className="study-list-tat-star"
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              </>
                          )}
              
                          {showForPrior && props.data.row.original.assignmentList[index]
                            ?.tatCategoryColorClassName === BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.COLOR_NAME && (<>
                            <span
                                 className="study-list-top-badge-item"
                                  style={{
                                    ...statusStyle,
                                    backgroundColor: BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.BACKGROUND,
                                    color: getColorValue(BADGE_INFO_OBJ.TAT_BETWEEN_3_TO_12_HR.TEXT_COLOR),
                                    marginLeft: "5px"
                                  }}
                                >
                                  {t("info-badge.tat-between-3-to-12-hr")}
                                  {checkTab() 
                                    ? ` ${props.data.row.original.assignmentList[index]?.tatDisplay} `
                                    : ""}
                                </span>
                                {checkTab()  &&
                              props.data.row.original.assignmentList[index].tatRating != "" &&
                              props.data.row.original.assignmentList[index].tatRating != "0" ? (
                                <div className="study-list-tat-start-badge" style={{ position: "unset", borderRadius: "0px 0px 7px 7px", marginLeft: "5px"}}>
                                  <span className="study-list-tat-start-text">
                                    {props.data.row.original.assignmentList[index].tatRating}
                                  </span>
                                  <Icon
                                    iconName="FavoriteStarFill"
                                    className="study-list-tat-star"
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                              </>
            )}
</span>

            { <Stack horizontal style={hospitalStackStyles}>
              <CustomToolTipHost content={t("label.tooltipMessageCreatedOn")}
              styles={{
                    root: {
                      display: "flex",
                      justifyContent: "center",
                      width: "auto",
                      alignItems: "center",
                      cursor: "pointer"
                    }
                  }}>
                <span className="study-list-study-date" style={{marginTop:"4px", display: "flex", alignItems: "flex-start"}}>
                  <span style={{display: "inline", whiteSpace: "nowrap"}}>
                    {t("sorting.study-list.created-on")}:
                  </span>
                  <span className="study-list-date">{
                    // props.data.row.original.uploadDateDisplay != "" &&
                    //   props.data.row.original.uploadDateDisplay != undefined &&
                    //   props.data.row.original.uploadDateDisplay
                    getConsistentCustomDateFormat(getAssignmentDate())
                    //  <RowBadge name={props.data.row.original.uploadDateDisplay} />
                  }</span>
                </span>
                </CustomToolTipHost>
                {/* <span>{props.data.row.original.assignmentList[0].clientName ? props.data.row.original.assignmentList[0].clientName : "-"}</span> */}
                {/* <div style={modalityStyle}>{props.data.row.original.modality.name}</div> */}
              </Stack>
              }
              {<Stack horizontal style={hospitalStackStyles}>
                <CustomToolTipHost
                  content={t("label.tooltipMessageUploadOn")}
                                  styles={{
                    root: {
                      display: "flex",
                      justifyContent: "center",
                      width: "auto",        // ← override 100%
                      alignItems: "center",
                      cursor: "pointer"
                    }
                  }}
                                >
                  <span className="study-list-study-date" style={{ marginTop: "0px", display: "flex", alignItems: "flex-start" }}>
                    <span style={{display: "inline", whiteSpace: "nowrap"}}>
                      Uploaded On:
                    </span>
                    <span className="study-list-date">
                      {
                        study.uploadDateDisplay && study.uploadDateDisplay !== "-"
                          ? getConsistentCustomDateFormat(study.uploadDateDisplay)
                          : "-"
                      }
                    </span>
                  </span>
                </CustomToolTipHost>
              </Stack>}
              {!(reviewerId && reviewerId == userId && (props.tabId == TAB_NAME.REVIEWASSIGNED || props.tabId == TAB_NAME.REVIEWCOMPLETE || props.tabId == TAB_NAME.EVALUATIONASSIGNED || props.tabId == TAB_NAME.EVALUATIONCOMPLETE)) &&
            <Stack horizontal style={submissionStackStyle}>
                    <ReportDetailsBadge data={props.data} index={0} tabId={props.tabId} />
                    {/* <ReportCountComponent data={props.data} /> */}
            </Stack>
          }
         

          {/* <div
          style={timeDateStyle}>
          <CustomToolTipHost content={props.data.row.original.studyDateDisplay} id={"tooltip_"}>
        {`Study Date: ${getFormatedDate(props.data.row.original.studyDateDisplay)}`}
        </CustomToolTipHost>
        </div> */}

          

          {/* <Stack horizontal style={reportOptionsStackStyle}>
          <EditReport />
          <Chat />
          <Download />
          <DownloadImage />
        </Stack> */}
        </Stack>
        {((checkForShowingExternalReportingActions()|| checkForAIReportDownloadAvailable()) && checkForAnyActionIsActive()) &&  
        <div 
        style={{
          width: props.data.row.depth === 0 ? "unset" : getEnv("REACT_APP_HYBRID_MODE") == "false" ? "24px" : "34px",
          marginRight :  roles[0]== USERTYPES.TYPIST ? "20px":"unset",
          marginTop: CUSTOM_STYLES.STUDYLIST_TD_TOP_MARGIN,
          display:"flex",
        }}
        className={`study-list-reporting-container ${props.data.row.depth != 0 ? "study-list-reporting-extra-margin":""}`}>
          {props.data.row.original.allowDirectSubmitReport &&
                props.data.row.original.assignmentList[0].closed == 0 &&
                roles[0] === USERTYPES.RADIOLOGIST && props.data.row.original.assignmentList[0].reportDoneStatus != 2 &&
                radiologistType != 2 && (
                  <CustomToolTipHost
                    content={t("heading.direct-submit-report")}
                    styles={customToolTipStyleForIcons}
                    id={"direct_submit_report"}
                  >
                    <div
                      className="study-list-report-icon"
                      style={{ marginBottom: "2px" }}
                      onClick={() => handleDirectSubmitReport(props.data.row.original.id)}
                    >
                      <DirectSubmitReport />
                    </div>
                  </CustomToolTipHost>
                )}
        {checkForExternalReportingAvailable() && <CustomToolTipHost
          content={t("heading.external-reporting")}
              styles={customToolTipStyleForIcons}
              id={"external_reporting"}
          ><div
            automation-id="external_reporting"
            onClick={() => {
              // if(isActiveData)
                handleEditReport();
            }}
            className={`study-list-report-icon`}
            style={{marginBottom:"2px"}}
          >
            <ReportingIcon />
          </div></CustomToolTipHost>}
          {checkForPreviewAvailable() &&(
              <CustomToolTipHost
          content={t("heading.preview-report")}
              styles={customToolTipStyleForPreview}
              id={"preview_report"}
          >
              <div
                style={{position:'relative',display:'flex',marginBottom:"2px"}}
                onClick={() => {
                  // if(isActiveData)
                  // Let the system decide: preview with key images if present, else plain report
                  const useDraftSnapshot = props.tabId === TAB_NAME.DRAFT;
                  if (study.keyImagePresent) {
                    handlePreviewReportWithKeyImage(studyId, study.reportDoneStatus, useDraftSnapshot);
                  } else {
                    handlePreviewReport(studyId, study.reportDoneStatus, useDraftSnapshot);
                  }
                }}
                className={`study-list-report-icon`}
              >
               <NavIcons iconName="preview" />
              </div></CustomToolTipHost>
            )}
          {(checkForDownloadAvailable() || checkForAIReportDownloadAvailable() || checkForPeerReviewReportDownloadAvailable())
            && (
              <div className={`study-list-report-icon ${!isActiveData ? 'disabled' : ''}`} style={{marginBottom:"2px"}}>
                 <CustomToolTipHost
          content={getDownloadReportTooltipText()}
              styles={customToolTipStyleForIcons}
              id={"download_report"}
          >
                <div
                  style={{position:'relative',display:'flex'}}
                  automation-id="studyList_report_download"
                  onClick={() => {
                    if (showInfo1) {
                      // console.log("False");
                      setShowInfo1(false);
                    } else {
                      // console.log("True");
                      setShowInfo1(true);
                    }
                  }}
                >
                  <DownloadReportIcon downloaded = {props.data.row.original.reportDownloaded || downloadedStudyIds.includes(studyId)} 
                  active = {hovering.download}/>
                 {(props.data.row.original.noOfReports > 0 && checkForDownloadAvailable()) && <div
                     
                      className="radiologist-column-progress-number-text"
                      style={{top: "-9px",right: "-11px"}}
                    >
                      <span className="radiolgist-column-progress-number-text-style">
                      {props.data.row.original.noOfReports}
                      </span>
                    </div>}
                  <DownloadOptions
                  studyParentId={study.id}
                  isStudyList={true}
                  show={showInfo1}
                  onClickOutside={() => {
                    setShowInfo1(false);
                  }}
                  modality={study.modality.name}
                  isKeyImagesPresent= {study.keyImagePresent}
                  isExtReportReceived={study.extReportReceived}
                  aiReportOptions={checkForAIReportDownloadAvailable()}
                  reportOptions={checkForDownloadAvailable()}
                  peerReviewReportOptions={checkForPeerReviewReportDownloadAvailable()}
                  downloadAIReport={downloadAIReport}
                  useDraftSnapshot={props.tabId === TAB_NAME.DRAFT}
                />
                </div></CustomToolTipHost>

                
              </div>
            )}
          {/* Download AI report */}
          {/* {checkForAIReportDownloadAvailable() && (
            <div className="study-list-report-icon">
              <CustomToolTipHost content={t("heading.download-ai-report")} styles={customToolTipStyleForIcons} id={"download_ai_report"}>

                  <div onClick={()=>downloadAIReport(study.id)}><DownloadReportIcon active = {hovering.downloadAIReport}/></div>
              
              </CustomToolTipHost>
            </div>
          )} */}
        </div>}
      </div>
    </>
  );
};

export default ReportDetails;

const ReportCountComponent = (props) => {

  const customToolTipStyleForIcons = {
    root: "study-list-report-image-count-container",
  }

  return (props.data.row.original.noOfReports > 0 && <div style={{display:'flex',marginTop:"5px",marginLeft:'5px',height:"100%"}}>
  <span>
    <CustomToolTipHost
      content={`${t("label.total-reports")} : ${props.data.row.original.noOfReports}`}
      styles={customToolTipStyleForIcons}
      id={"tooltip_"}
    >
      <ReportCount />{" "}
      <span className="study-list-study-imagecount">
        {props.data.row.original.noOfReports < 10 ? "0" : ""}
        {props.data.row.original.noOfReports}
      </span>
    </CustomToolTipHost>
  </span>
</div>)
}
